"use client";

import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export const GclidStore = () => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const gclid = searchParams.get("gclid");

    // Only set the cookie if gclid is in URL and the cookie doesn't already exist
    if (gclid && !document.cookie.includes("gclid=")) {
      const expiryDate = new Date();
      expiryDate.setDate(expiryDate.getDate() + 30);

      document.cookie = `gclid=${gclid}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Strict`;
    }
  }, [searchParams]); // This will run on first load and when searchParams changes

  return null;
};

export default GclidStore;
